module.exports = __webpack_public_path__ + "static/media/lightgreen.78131d20.png";